<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      code: this.$route.query.code
    }
  },
  created: function () {
    if (localStorage.getItem('token') && localStorage.getItem('refresh_token')) {
      this.$store.dispatch('SET_TOKEN', JSON.parse(localStorage.getItem('token')))
      this.$store.dispatch('SET_REFRESH_TOKEN', JSON.parse(localStorage.getItem('refresh_token')))
    } else {
      if (this.code) {
        this.$store.dispatch('GET_TOKENS', this.code)
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style>

body {
    margin: 0px;
    background-color: #ffffff;
    overflow-y: scroll;
    overflow-x: hidden;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

</style>
